import cx from "classnames";

import styles from "./styles.module.scss";

/**
 *
 * @param {object} param0
 * @param {import("react").ReactNode} param0.children
 * @param {string} param0.className
 * @param  {...any} rest
 * @returns
 */
const Column: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className, ...rest }) => {
  return (
    <div className={cx(styles.col, className)} {...rest}>
      {children}
    </div>
  );
};

export default Column;
